import React from 'react';
import { Redirect } from "react-router-dom";

import { logoff } from "../helpers/authHelper";
const Logoff = (props) => {
  logoff();
  return (
    <Redirect to="/" />)
}

export default Logoff;